<script setup>
import { ALL_GROWERS } from '../composables/useGrowerFilter.js';

const props = defineProps({
	growers: { type: Array, required: true },
	selectedGrower: { type: String, required: true },
	growerKey: { type: Function, required: true }
});

defineEmits(['select']);
</script>

<template>
	<div v-if="growers.length" class="tnt-grower-panel" style="display: block">
		<h3 class="tnt-section-title tnt-grower-heading" style="display: flex">
			Grower
			<button type="button" class="tnt-info-trigger">
				<span class="tnt-info-tip" role="tooltip">Click a grower's card to filter the results below to just that grower. Click "All Growers" to clear the filter.</span>
			</button>
		</h3>
		<div class="tnt-grower-info-list">
			<button
				v-if="growers.length > 1"
				type="button"
				class="tnt-grower-info-card tnt-grower-all"
				:class="{ active: selectedGrower === ALL_GROWERS }"
				@click="$emit('select', ALL_GROWERS)"
			>
				<div class="tnt-grower-name">All Growers ({{ growers.length }})</div>
			</button>
			<button
				v-for="grower in growers"
				:key="growerKey(grower)"
				type="button"
				class="tnt-grower-info-card"
				:class="{ active: selectedGrower === growerKey(grower) }"
				@click="$emit('select', growerKey(grower))"
			>
				<div class="tnt-grower-name">{{ grower.name || 'Unknown Grower' }}</div>
				<div v-if="grower.address || grower.city || grower.state || grower.zip" class="tnt-grower-address">
					<template v-if="grower.address">{{ grower.address }}<br></template>
					{{ [grower.city, grower.state, grower.zip].filter(Boolean).join(', ') }}
				</div>
			</button>
		</div>
	</div>
</template>
